<!--<h1 mat-dialog-title>{{ fileName }}</h1>-->
<!--<div mat-dialog-content style="overflow: auto;" [attr.inert]="isDialogOpen ? true : null" inert>-->
<!--<div mat-dialog-content style="overflow: auto;">

  <div *ngIf="fileUrl && fileName.endsWith('.pdf')">
    <iframe [src]="sanitizedUrl" width="600" height="400"></iframe>
  </div>



  <div *ngIf="fileUrl && (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png'))">
    <img [src]="fileUrl" alt="Image Preview" style="max-width: 100%; max-height: 600px;" />
  </div>

  <div *ngIf="fileUrl && !fileName.endsWith('.pdf') && !(fileName.endsWith('.jpg') || fileName.endsWith('.png'))">
    <p>Unsupported file type or the file could not be loaded.</p>
  </div>

  <div *ngIf="!fileUrl">
    <p>Unable to load the file. Please try again later.</p>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Close</button>
</div>-->


<h1 mat-dialog-title>{{ fileName }}</h1>

<div mat-dialog-content style="overflow: auto; display: flex; justify-content: center; align-items: center; height: 80vh;">

  <div *ngIf="fileUrl && fileName.endsWith('.pdf')" style="width: 100%; height: 100%;">
    <iframe [src]="sanitizedUrl" style="width: 100%; height: 100%; border: none;"></iframe>
  </div>

  <div *ngIf="fileUrl && (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png'))">
    <img [src]="fileUrl" alt="Image Preview" style="max-width: 100%; max-height: 80vh; object-fit: contain;" />
  </div>

  <div *ngIf="fileUrl && !fileName.endsWith('.pdf') && !(fileName.endsWith('.jpg') || fileName.endsWith('.png'))">
    <p>Unsupported file type or the file could not be loaded.</p>
  </div>

  <div *ngIf="!fileUrl">
    <p>Unable to load the file. Please try again later.</p>
  </div>

</div>

<div mat-dialog-actions style="display: flex; justify-content: flex-end;">
  <button mat-button (click)="onClose()">Close</button>
</div>
